// Bootstrap only a session the visitor already requested. This is a UI hint;
// Firebase and the API remain responsible for authentication and permissions.
export async function hasSavedSignIn() {
  const key = `firebase:authUser:${process.env.REACT_APP_FIREBASE_API_KEY}:[DEFAULT]`;
  for (const name of ['localStorage', 'sessionStorage']) {
    try { if (JSON.parse(window[name].getItem(key))?.uid) return true; } catch { /* Storage may be blocked. */ }
  }
  if (!window.indexedDB) return false;
  try {
    if (typeof indexedDB.databases === 'function') {
      const databases = await indexedDB.databases();
      if (!databases.some(db => db.name === 'firebaseLocalStorageDb')) return false;
    }
  } catch { return false; }
  return new Promise(resolve => {
    let db, done = false;
    const finish = value => { if (done) return; done = true; clearTimeout(timer); db?.close(); resolve(value); };
    const timer = setTimeout(() => finish(false), 1500);
    try {
      const request = indexedDB.open('firebaseLocalStorageDb');
      // Never create a database merely by visiting a public page.
      request.onupgradeneeded = () => { request.transaction.abort(); finish(false); };
      request.onerror = request.onblocked = () => finish(false);
      request.onsuccess = () => {
        db = request.result;
        if (done) { db.close(); return; }
        if (!db.objectStoreNames.contains('firebaseLocalStorage')) { finish(false); return; }
        try {
          const transaction = db.transaction('firebaseLocalStorage', 'readonly');
          const read = transaction.objectStore('firebaseLocalStorage').get(key);
          let present = false;
          read.onsuccess = () => { present = Boolean(read.result?.value?.uid); };
          transaction.oncomplete = () => finish(present);
          transaction.onerror = transaction.onabort = () => finish(false);
        } catch { finish(false); }
      };
    } catch { finish(false); }
  });
}
